module.exports = __webpack_public_path__ + "static/img/head.d7af5023.png";